// 订单快照页面
<template>
	<div > 	
		<div class="sld_goods_detail">
			<!-- 内容区顶部固定 start -->
			<div class="contain_con" v-if="containCon">	
				<div class="contain_content">
					<div class="goods_description_title flex_row_start_center">					
						<div class="cursor_pointer goods_tab_item" :class="{ description_active: goodsDesctionType == 'detail' }"
						>{{ L['商品详情'] }}</div>						
						
					</div>				
				</div>				
			</div>
			<!-- 内容区顶部固定 end -->
			
			<div class="goods_detail_content" v-if="goodsDetail.data">
				<!-- 商品所属分类  start-->
				<div class="goods_about_con flex_row_start_center">					
						<div class="goods_classify ">
							<span >
								<router-link style="color: #000000;"  to="/">
									首页</router-link>
							</span>
					</div>
				</div>
				<!-- 商品所属分类 end-->
				<!-- 商品主要信息 start -->
				<div class="main_con">
					<!-- 商品相关 start -->
					<div class="goods_des">
						<!-- 商品图片列表 start -->
						<div class="goods_des_left">
							<!-- 商品图片列表 start -->
							<div :class="{
								goods_picture_con: true,
								flex_column_between_center: true,
								skeleton_goods_picture_con: firstLoading
							}" v-if="goodsDetail.data.goodsImgList && goodsDetail.data.goodsImgList.length > 0">
								
								<div class="showPic_arrow" :class="{noShow:goodsDetail.data.goodsImgList.length<=ShowPicMaxNum}">
									<img  v-if='curShowPicIndex == 0' class="ni_arraw_up disable" src="@/assets/goods/up_arraw_gray.png" alt=""
										@click="switchDefaultImage('left')"/>
									<img v-else class="ni_arraw_up" src="@/assets/goods/up_arraw.png" alt=""
										@click="switchDefaultImage('left')"/>	
								</div>
								
								<div class="show_box">
									<ul class="goods_picture_list flex_column_start_center" ref="goodsPictureList">
										<li v-for="(goodsImgItem, goodsImgIndex) in goodsDetail.data
											.goodsImgList" :key="goodsImgIndex" class="goods_img"
											:class="{ goods_img_active: currentDefaultImage == goodsImgIndex }"
											@click="selectDefaultImage(goodsImgItem, goodsImgIndex)"
											@mouseover="selectDefaultImage(goodsImgItem, goodsImgIndex)">
											<div class="goods_image" :style="{
												backgroundImage: 'url(' + goodsImgItem + ')'
											}"></div>
										</li>
									</ul>
								</div>
								<div class="showPic_arrow" :class="{noShow:goodsDetail.data.goodsImgList.length<=ShowPicMaxNum}">
									<img  v-if='curShowPicIndex ==
										goodsDetail.data.goodsImgList.length - ShowPicMaxNum' class="ni_arraw_down disable" src="@/assets/goods/down_arraw_gray.png" alt=""
										@click="switchDefaultImage('right')"/>
									<img v-else class="ni_arraw_down" src="@/assets/goods/down_arraw.png" alt=""
										@click="switchDefaultImage('right')"/>	
								</div>
								
							</div>
							<!-- 商品图片列表 end -->
							<!-- 商品放大镜效果 start-->
							<div class="goods_main">
								<div class="goods_main_picture">
									<div class="preview-box" @mousemove="move($event)" @mouseleave="out($event)" @mouseenter="enter($event)"
										ref="previewBox">
										<div class="imageBorder" :class="{
											default_image: true,
											skeleton_default_image: firstLoading
										}" :style="{ backgroundImage: 'url(' + defaultImage + ')' }">
											<template v-if="currentDefaultImage == -1 && goodsDetail.data.goodsVideo">
												<video  controls muted playsinline="playsinline" class="video  imageBorder default_image" :poster="defaultImage" autoplay
													ref="video">
													<source :src="goodsDetail.data.goodsVideo" type="video/mp4" />
												</video>
												<img class="video_close_icon" @click="closeVideo"    src="@/assets/goods/close_white.png"/>
											</template>
										</div>
										<div class="v_btn" v-if="currentDefaultImage == 0 && goodsDetail.data.goodsVideo
											">
											<img src="@/assets/goods/playV.png" alt="" @click="playV" />
										</div>
										<!-- 遮罩 start-->
										<div class="mask" ref="maskBox" v-show="maskShow"></div>
										<!-- 遮罩 end -->
										
									</div>
									<!-- 右侧的放大后的图片 start -->
									<div class="goods_picture_big" style="border:1px solid #eee" ref="zoomBox" v-show="maskShow">
										<div class="default_image_big" :style="{ backgroundImage: 'url(' + defaultImage + ')' }"
											ref="pictureBig">
										</div>
									</div>
									<!-- 右侧的放大后的图片 end -->
								</div>
								<!-- 商品放大镜效果 end -->
							</div>	
						</div>
						<!-- 商品图片列表 end -->
						<!-- 商品详细信息 start -->
						<div class="m_item_inner">
							<div class="item_info">
								<div :class="{
									detaile_name: true,
									skeleton_detaile_name: firstLoading
								}">
									{{goodsDetail.data.goodsName}} {{goodsDetail.data.defaultSpecValues}}
								</div>
								<div :class="{ p_ad: true, skeleton_p_ad: firstLoading }" v-if="goodsDetail.data.goodsBrief">
									{{ goodsDetail.data.goodsBrief }}
								</div>
								
							
								<!-- price start -->
								<div class="price_pannel flex_row_start_end">								
									
								
									<div class="sell_price flex_row_start_end" >											
										<div class="unit">{{ L['¥'] }} </div>
										<div class="price_int">{{goodsDetail.data.productPrice&&goodsDetail.data.productPrice.toFixed(2) }}</div>
									</div>
									
									
								</div>																
								<!-- price end -->								
								<!-- 选择配置start -->
								<template v-if='goodsDetail.data.specValueList&&goodsDetail.data.specValueList.length>0'>
									<div class="common_title big">选择配置</div>
									<div class="spec_list flex_row_between_center">
										<div class="spec_value flex_row_center_center " :class="{'selected':curSpecIndex==spec_index}"											
										 v-for="(spec_item,spec_index) in goodsDetail.data.specValueList" :key="spec_index" >
											<div class="spec_content overflow_ellipsis_two">{{spec_item}}</div>										
										</div>
									</div>
									
								</template>	
								<!-- 选择配置end -->
								<div class="explain">
									<div class="explain_0">现在查看的是商品快照</div>	
									<div class="explain_0">该快照生成于 {{formatTime(goodsDetail.data.payTime)}}</div>
									<div class="explain_1" @click="goGoodsDetail">点此查看最新的商品详情</div>
								</div>	

							</div>
							
						</div>
						<!-- 商品详细信息 end -->
					</div>
					<!-- 商品相关 end -->
					
					
					<!-- 各种信息的切换 start -->
					<div class="container" ref="container" id="container">						
						<!-- 商品详情 评价 商品服务   start-->
						<div class="goods_description">
							<div class="goods_description_tab">
								<div class="contain_content">
									<div class="goods_description_title flex_row_start_center">					
										<div class="cursor_pointer goods_tab_item" :class="{ description_active: goodsDesctionType == 'detail' }"
											>{{ L['商品详情'] }}
										</div>
									</div>				
								</div>	
							</div>			
							
							<div class="goods_description_con">
								<div class="goods_pannel">
									<!-- 商品详情,规格参数,及详情富文本 start-->
									<div class="goods_des_con" v-if="goodsDesctionType == 'detail'">
										<div v-if="goodsDetail.data.goodsDetails
											">
											<div v-if="goodsDetail.data.goodsDetails != undefined &&
												goodsDetail.data.goodsDetails
												" class="goods_html" :style="goodsDetail.data.goodsDetailsBg">
												<div class="goods_htmls" v-html="goodsDetail.data.goodsDetails">
												</div>
											</div>
											
										</div>
										<div v-else>
											<SldCommonEmpty :tip="L['该商品暂无详情~']" totalWidth="800px" />
										</div>
									</div>
									<!-- 商品详情,规格参数,及详情富文本 end-->
								</div>	
							</div>
						</div>
						<!-- 商品详情 评价 商品服务 店铺热销  end-->
					</div>
					<!--各种信息的切换 end -->
				</div>
				<!-- 商品主要信息 end -->
			</div>
		</div>
	</div>
	
</template>

<script>
import addrData from '@/assets/area.json'
import {
	reactive,
	getCurrentInstance,
	ref,
	onMounted,	
} from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage,} from 'element-plus'
import { useStore } from 'vuex'
import SldCommonEmpty from '../../components/SldCommonEmpty'

export default {
	name: 'goods-detail',
	components: {	
		SldCommonEmpty,	
	},
	setup() {
		const firstLoading = ref(true) //是否第一次加载
		const router = useRouter()
		const route = useRoute()
		const store = useStore()
		//add
		const key=ref('')
		const goodsDetail = reactive({ data: {} }) //商品详情数据		
		const goodsDesctionType = ref('detail') //商品详情,评价,商品服务,店铺热销,默认显示商品详情
		const curSpecIndex=ref(0)
		const ShowPicMaxNum=ref(5) 
		const curShowPicIndex=ref(0);//当前显示第一个图片的index
	
		const goodsPictureList = ref(null) //商品图片列表

		const containCon = ref(false) //固定内容区头部
		
		const { proxy } = getCurrentInstance()
		const L = proxy.$getCurLanguage()		
		
		const pictureBig = ref(null) //大图的信息
		const maskBox = ref(null) //遮罩盒子的信息
		const maskShow = ref(false) //遮罩是否显示
		const previewBox = ref(null) // 左侧主图元素信息
		const zoomBox = ref(null) //左侧主图的父元素的信息
		const defaultImage = ref('') //默认主图路径
		const currentDefaultImage = ref('0') //默认主图显示第一张

		onMounted(() => {			
			key.value = route.query.key	
			getOrderProductSnapshot()
			window.addEventListener('scroll', scrollHandle) //绑定页面滚动事件
		})
	
		const scrollHandle = async e => {
			let elementScrollTop = e.srcElement.scrollingElement.scrollTop //获取页面滚动高度
			if (
				document.getElementById('container') &&
				elementScrollTop >= document.getElementById('container').offsetTop
			) {				
				containCon.value = true
			
			} else {		
				containCon.value = false
				
			}
		}

		// 点击播放视频
		const playV = () => {
			currentDefaultImage.value = -1
			defaultImage.value = ''
			maskShow.value = false
			videoEnd()
		}
		const doInit=(res)=>{
			goodsDetail.data=res.data;
			document.title = res.data['goodsName']	
			if (goodsDetail.data.goodsDetails) {
				goodsDetail.data.goodsDetails = proxy.$quillEscapeToHtml(
					goodsDetail.data.goodsDetails
				)
				//处理背景样式
				if (
					goodsDetail.data.goodsDetails.indexOf(
						'<p style="display:none;" data-background="'
					) != -1
				) {
					let bg = goodsDetail.data.goodsDetails
						.split('<p style="display:none;" data-background="')[1]
						.split('">')[0]
					goodsDetail.data.goodsDetailsBg = bg
				}
			}
			if(res.data["goodsVideoImage"]&&res.data["goodsVideo"]){
				if(!res.data.goodsImgList){
					res.data.goodsImgList=[]
				}
				res.data.goodsImgList.unshift(res.data["goodsVideoImage"])				
			}
			defaultImage.value = res.data.goodsImgList[0]
			goodsDetail.data.goodsImgList = res.data.goodsImgList
			for(let i=0;i<res.data.specValueList.length;i++){
				if(res.data.specValueList[i]==res.data.defaultSpecValues){
					curSpecIndex.value=i;
					break;
				}
			}
			
		}

		const getOrderProductSnapshot = () => {
			let params = {
				"key":key.value
			}
			proxy
				.$get('/v3/business/front/orderPay/orderProductSnapshot', params)
				.then(res => {
					//just for test
					//res=getTestDetial()

					if (res.state == 200) {
						doInit(res)
					}else{
						ElMessage(res.msg)
					}
						
				})
				.then(() => {
					
				})
		}
		
		
		
		//去商品详情页
		const goGoodsDetail = () => {
			proxy.$goGoodsDetail(goodsDetail.data.productId);
		};
		
		//视频播放结束时触发
		const videoEnd = () => {
			proxy.$nextTick(() => {
				proxy.$refs.video.onended = () => {
					currentDefaultImage.value = 0
					defaultImage.value = goodsDetail.data.goodsImgList[0]
				}
			})
		}
		
		const closeVideo=()=>{
			currentDefaultImage.value = 0
			defaultImage.value = goodsDetail.data.goodsImgList[0]
		}
	
		//选择商品主图
		const selectDefaultImage = (goodsImgItem, goodsImgIndex) => {
			defaultImage.value = goodsImgItem
			currentDefaultImage.value = goodsImgIndex
		}

		//切换商品主图
		const switchDefaultImage = type => {
			let defaultImagelength = goodsDetail.data.goodsImgList.length
			if (type == 'left') {
				currentDefaultImage.value--
				if (currentDefaultImage.value <= 0) {
					currentDefaultImage.value = 0
				}
				defaultImage.value =
					goodsDetail.data.goodsImgList[currentDefaultImage.value]
				
				curShowPicIndex.value--;	
				if (curShowPicIndex.value <= 0) {
					curShowPicIndex.value = 0
				}
			} else {
				currentDefaultImage.value++
				
				if (currentDefaultImage.value >= defaultImagelength) {
					currentDefaultImage.value = defaultImagelength - 1
					
				}
				defaultImage.value =
					goodsDetail.data.goodsImgList[currentDefaultImage.value]
					
				curShowPicIndex.value++
				let diffNum=defaultImagelength-ShowPicMaxNum.value   //5 是能显示的最大数量
				if(curShowPicIndex.value>diffNum){
					curShowPicIndex.value--
				}
			}
			goodsPictureListsTop()
		}
		//图片列表的left移动的距离
		const goodsPictureListsTop = () => {
			//获取 goods_picture_list 的元素
			let goodsPictureLists = goodsPictureList.value
			let num=ShowPicMaxNum.value-1;
			//列表默认显示5张图片
			if (
				goodsDetail.data.goodsImgList.length > 5 &&
				currentDefaultImage.value >= 0
			) {
				/* 分析找规律：
					如果有8张图片，点击右键 最大可以向左移动的距离为 8 - 5既3张图，left移动的距离为 3 * - 66px; currentDefaultImage.value从0开始的
					其中：66px为每一个元素需要每次移动的距离 为图片的宽度与图片之间的间距的和
					currentDefaultImage.value == 4；goodsPictureLists.style.left = 0；
					currentDefaultImage.value == 5；goodsPictureLists.style.left = (5-4) (1) * -66px；
					currentDefaultImage.value == 6；goodsPictureLists.style.left = (5-2) (2) * -66px；
					currentDefaultImage.value == 7；goodsPictureLists.style.left = (5-3) (2) * -66px；
					 点击左键，最大可以向右移动的距离为 8 - 5 即3张
					 currentDefaultImage.value == 0；goodsPictureLists.style.left = 0；
					 currentDefaultImage.value == 1； goodsPictureLists.style.left = -66px；
					 currentDefaultImage.value == 2; goodsPictureLists.style.left = 2 * -66px；
					 currentDefaultImage.value == 3; goodsPictureLists.style.left = 3 * -66px；
				*/
				if (currentDefaultImage.value > num) {
					goodsPictureLists.style.top =
						(currentDefaultImage.value - num) * -85 + 'px'
				}
				if (
					currentDefaultImage.value <
					goodsDetail.data.goodsImgList.length - num
				) {
					goodsPictureLists.style.top = currentDefaultImage.value * -85 + 'px'
				}
			}
		}

		//获取元素距离父元素的顶部及左边的距离
		const offset = el => {
			let top = el.offsetTop
			let left = el.offsetLeft
			while (el.offsetParent) {
				el = el.offsetParent
				top += el.offsetTop
				left += el.offsetLeft
				
			}
			return {
				left: left,
				top: top
			}
		}

		//鼠标移动
		const move = e => {
		
			if (currentDefaultImage.value == -1) {
				return
			}

			//主图父元素的信息 宽，高
			let previewsBox = previewBox.value
			let previewBoxWidth = previewsBox.offsetWidth
			let previewBoxHeight = previewsBox.offsetHeight
			//主图父元素距离顶部的距离
			let previewsBoxLeft = offset(previewsBox).left
			let previewsBoxTop = offset(previewsBox).top

			// 遮罩盒子的信息宽，高
			let masksBox = maskBox.value
			let maskBoxWidth = masksBox.offsetWidth
			let maskBoxHeight = masksBox.offsetHeight
			//鼠标距离屏幕距离
			let moveX = e.clientX
			let moveY = e.clientY

			//获取左侧大图父元素的信息
			let zoomsBox = zoomBox.value
			let zoomBoxWidth = zoomsBox.offsetWidth
			let zoomBoxHeight = zoomsBox.offsetHeight

			// 获取大图元素的信息宽，高
			let pictureBigBox = pictureBig.value
			let pictureBigWidth = pictureBigBox.offsetWidth
			let pictureBigHeight = pictureBigBox.offsetHeight

			//获取滚动条的高度
			let scroll = document.documentElement.scrollTop || document.body.scrollTop

			//主图距离父元素的left及top值
			let left = moveX - previewsBoxLeft - maskBoxWidth / 2
			let top
			if (scroll > 0) {
				top = moveY - previewsBoxTop + scroll - maskBoxHeight / 2
			} else {
				top = moveY - previewsBoxTop - maskBoxHeight / 2
			}
			

			//移动限制最大宽度，及最大高度
			let maxWidth = previewBoxWidth - maskBoxWidth
			let maxHeight = previewBoxHeight - maskBoxHeight
			

			left = left < 0 ? 0 : left > maxWidth ? maxWidth : left
			top = top < 0 ? 0 : top > maxHeight ? maxHeight : top
			
			//比列
			let parcentX = left / maxWidth
			let parcentY = top / maxHeight

			//遮罩层的定位值
			maskBox.value.style.left = left + 'px'
			maskBox.value.style.top = top + 'px'

			//大图元素的定位值
			pictureBig.value.style.left =
				parcentX * (zoomBoxWidth - pictureBigWidth) + 'px'
			pictureBig.value.style.top =
				parcentY * (zoomBoxHeight - pictureBigHeight) + 'px'
			pictureBig.value.style.width =
				(previewBoxWidth / maskBoxWidth) * zoomBoxWidth + 'px'
			pictureBig.value.style.height =
				(previewBoxHeight / maskBoxHeight) * zoomBoxHeight + 'px'
		}
		//鼠标移出
		const out = () => {
			maskShow.value = false
		}

		//鼠标移入
		const enter = () => {
			if (currentDefaultImage.value == -1) {
				return
			}			
			maskShow.value = true
		}

		const formatTime=(dataStr)=>{
			if(dataStr){				
				return dataStr.replace(/-/g, '.');
			}else{
				return ''
			}
		}

		const getTestDetial=()=>{
			  return{
				"data": {
					"goodsVideo": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcvideos/seller/video/pYhV0DQ2a1Q7Cdrnums.mp4,https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcvideos/seller/video/MHK9csrRco1inuU4H4T.mp4",
	
					"defaultSpecValues": "1TB",
					"goodsDetails": "&lt;p&gt;&lt;img src=\"https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/eLYWZmspD3Xo5uqvIKF.jpg?bindId=64\"/&gt;&lt;img src=\"https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/eLYWZmspD3Xo5uqvIKF.jpg?bindId=64\"/&gt;&lt;img src=\"https://static.asus.com.cn/store/20240625/10495450534810.png\"/&gt;&lt;img src=\"https://static.asus.com.cn/store/20240620/10392297981019.jpg\"/&gt;&lt;img src=\"https://static.asus.com.cn/store/20240625/16441510257501.jpg\"/&gt;&lt;img src=\"https://static.asus.com.cn/store/20240306/16545951995756.jpg\"/&gt;&lt;img src=\"https://static.asus.com.cn/store/20240306/16550052491025.jpg\"/&gt;&lt;img src=\"https://static.asus.com.cn/store/20240306/16550052491025.jpg\"/&gt;&lt;img src=\"https://static.asus.com.cn/store/20240306/16550052545255.jpg\"/&gt;&lt;img src=\"https://static.asus.com.cn/store/20240306/16550052971001.jpg\"/&gt;&lt;img src=\"https://static.asus.com.cn/store/20240306/16550153485153.jpg\"/&gt;&lt;/p&gt;",
					
					"productId": 42228873557678,
					"specValueList": ["512GB", "1TB"],
					"payTime": "2025-03-15 15:50:28",
					"goodsVideoImage": "",
					"goodsBrief": "阿达",
					"productNum": 1,
					"goodsName": "gq测试商品别动",
					"productPrice": 100.00,
					"goodsImgList": ["https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/Y2E7kV5aHA8lQlchWox.png?bindId=96", "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/6PvzvEADgthZFD6NW5s.jpg?bindId=80","https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/Y2E7kV5aHA8lQlchWox.png?bindId=96", "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/6PvzvEADgthZFD6NW5s.jpg?bindId=80","https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/Y2E7kV5aHA8lQlchWox.png?bindId=96", "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/6PvzvEADgthZFD6NW5s.jpg?bindId=80"]
				},
				"msg": "成功",
				"state": 200,
				"timestamp": 1742179905248
			}
		}

		
		//暴露的变量及方法
		return {
			L,
			//add
			key,
			formatTime,
			containCon,
			closeVideo,
			playV,
			curSpecIndex,
			goodsDesctionType,
			goodsDetail,
			goodsPictureList,
			pictureBig ,
			maskBox ,
			maskShow,
			previewBox,
			zoomBox ,
			defaultImage ,
			currentDefaultImage,
			move,
			out,
			enter,		
			selectDefaultImage,
			switchDefaultImage,
			ShowPicMaxNum,
			curShowPicIndex,
			goGoodsDetail

		}
	}
}
</script>

<style lang="scss" scoped>
@import '../../style/base.scss';
@import '../../style/iconfont.css';
@import '../../style/goodsDetailSnapshot.scss';


.sld_goods_detail {
	.goods_htmls {
		::v-deep p {
			line-height: 20px;
		}
		::v-deep .ql-video {
			width: 525px;
			height: 315px;
		}
		::v-deep a {
			display: inline-block;
			margin: 5px auto;
			color: #0000ff;
			text-decoration: underline;
		}
		::v-deep table {
			border-collapse: collapse;
			padding: 0;
		}
		::v-deep td {
			border: 1px solid #ddd;
			padding: 5px 10px;
		}
		::v-deep th {
			border: 1px solid #ddd;
			padding: 5px 10px;
		}
		::v-deep ol {
			padding-left: 10px;
			::v-deep li{
				list-style: unset;
			}
		}
		::v-deep ul {
			padding-left: 10px;
			::v-deep li{
				list-style: unset;
			}
		}
	}
}




.imageBorder {
	position: relative;
	border: 1px solid #eee;
}

.goods_picture_big {
	border: 1px solid #eee;
}


</style>
